/**
 * Motivos de consulta predefinidos para Cita Rápida — Podología.
 * 
 * Cada motivo se asigna a un tratamiento existente en la clínica.
 * Si el tratamiento no existe, el backend lo crea automáticamente.
 */
const MOTIVOS_PODOLOGIA = [
  {
    id: 'onicocriptosis',
    label: '🔴 Dolor uña encarnada',
    tratamiento: 'general',
    duracion: 60,
  },
  {
    id: 'helomas',
    label: '🟡 Callos / helomas',
    tratamiento: 'general',
    duracion: 60,
  },
  {
    id: 'onicomicosis',
    label: '🟢 Onicomicosis (hongos)',
    tratamiento: 'general',
    duracion: 60,
  },
  {
    id: 'diabetico',
    label: '🔵 Control pie diabético',
    tratamiento: 'general',
    duracion: 60,
  },
  {
    id: 'control',
    label: '⚪ Control rutinario',
    tratamiento: 'general',
    duracion: 30,
  },
  {
    id: 'manicura',
    label: '💅 Manicura',
    tratamiento: 'manicura',
    duracion: 60,
  },
  {
    id: 'otro',
    label: 'Otro motivo',
    tratamiento: 'general',
    duracion: 60,
  },
];

export default MOTIVOS_PODOLOGIA;
